import { getCommonMetaTags } from '~/utils/get-common-meta-tags';
import { getDescription } from './get-description';

export function getPostMetaTags({
  _type,
  _updatedAt,
  title,
  content,
  lead,
  publishedAt,
  author,
  ogImageUrl,
  ogType,
  path,
  cards,
  isCardsType = false,
}) {
  const section = _type.toLowerCase();

  const description = isCardsType
    ? getDescription({ content: cards[0]?.content })
    : getDescription({ content: lead }) || getDescription({ content });

  const baseMetaTags = getCommonMetaTags({
    path,
    ogImageUrl,
    ogType,
    title,
    description,
  });

  return [
    ...baseMetaTags,
    {
      hid: 'article:published_time',
      property: 'article:published_time',
      content: publishedAt || '',
    },
    {
      hid: 'article:modified_time',
      property: 'article:modified_time',
      content: _updatedAt || '',
    },
    {
      hid: 'article:author',
      property: 'article:author',
      content: author || '',
    },
    {
      hid: 'article:section',
      property: 'article:section',
      content: section,
    },
  ];
}
